import { ANSWERS } from './data/answers';
import { GUESSES } from './data/guesses';

const guessSet = new Set(GUESSES);

/** True if the word is in the accepted-guess list (case-insensitive). */
export function isValidGuess(word: string): boolean {
  return guessSet.has(word.toLowerCase());
}

export { ANSWERS, GUESSES };
